import React, { useState } from "react";
import { GridToolbarContainer } from "@mui/x-data-grid";
import { Typography, TextField, Button, Box } from "@mui/material";

//Exported standalone — reusable anywhere
export function GoToPageControls({ totalPages, onPageChange }) {
  const [goToPage, setGoToPage] = useState("");

  const goToPlaceholder = `1–${totalPages}`;
  const textFieldWidth = 56 + goToPlaceholder.length * 8;

  const handleGoToPage = () => {
    const parsed = parseInt(goToPage, 10);
    if (!isNaN(parsed) && parsed >= 1 && parsed <= totalPages) {
      onPageChange(parsed);
    }
    setGoToPage("");
  };

  return (
    <Box
      display="flex"
      alignItems="center"
      gap={1}
      flexShrink={0}
      sx={{ width: "max-content" }}
    >
      <Typography variant="body2" color="text.secondary">
        Go to page
      </Typography>
      <TextField
        size="small"
        type="number"
        value={goToPage}
        onChange={(e) => setGoToPage(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") handleGoToPage();
        }}
        inputProps={{ min: 1, max: totalPages }}
        placeholder={goToPlaceholder}
        sx={{ width: textFieldWidth }}
      />
      <Button
        size="medium"
        variant="outlined"
        onClick={handleGoToPage}
        disabled={
          !goToPage ||
          parseInt(goToPage, 10) < 1 ||
          parseInt(goToPage, 10) > totalPages
        }
      >
        Go
      </Button>
    </Box>
  );
}

//Default export — DataGrid toolbar wrapper (0-indexed)
function GoToPageToolbar({ totalPages, page, onPageChange }) {
  return (
    <GridToolbarContainer
      style={{
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        padding: "0 1em",
        borderBottom: "1px solid lightgray",
        minHeight: "4.2em",
      }}
    >
      <GoToPageControls
        totalPages={totalPages}
        onPageChange={(parsed) => onPageChange(parsed - 1)}
      />
    </GridToolbarContainer>
  );
}

export default GoToPageToolbar;
